import { Injectable } from "@angular/core";
import { HttpClient, HttpContext } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { Observable } from "rxjs";
import { marker } from "@jsverse/transloco-keys-manager/marker";
import { UserNotify } from "src/app/support/notify-decorator";
import { Attachment, AttachmentV2 } from "../models/attachment/attachment";
import { AttachmentUpdate } from "../models/attachment/attachment.update";
import { AttachmentDelete } from "../models/attachment/attachment.delete";
import { HTTP_CONTEXT_TOKEN_NO_SWAP_DEEP_PROPERTY_ID } from "src/app/core/http-context-tokens";

@Injectable()
export class AttachmentBackend {
  constructor(private http: HttpClient) {}

  load(id: string): Observable<Attachment> {
    return this.http.get<Attachment>(
      `${environment.snoots.api.diagnostic}/attachments/${id}`
    );
  }

  loadLight(id: string): Observable<Attachment> {
    return this.http.get<Attachment>(
      `${environment.snoots.api.diagnostic}/attachments/${id}`,
      {
        params: { light: true }
      }
    );
  }

  @UserNotify({
    successMessage: marker("Allegato aggiornato"),
    errorMessage: marker("Non è stato possibile aggiornare l'allegato")
  })
  update(
    request: Partial<AttachmentUpdate>,
    id: string
  ): Observable<Attachment> {
    return this.http.patch<Attachment>(
      `${environment.snoots.api.diagnostic}/attachments/${id}`,
      request
    );
  }

  @UserNotify({
    successMessage: marker("Allegato rimosso"),
    errorMessage: marker("Non è stato possibile rimuovere l'allegato")
  })
  delete(request: AttachmentDelete): Observable<string> {
    return this.http.delete<string>(
      `${environment.snoots.api.diagnostic}/attachments/${request.id}`
    );
  }
}
